import { render, staticRenderFns } from "./ThanksLetters.vue?vue&type=template&id=6bbc5b44"
import script from "./ThanksLetters.vue?vue&type=script&lang=js"
export * from "./ThanksLetters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports